<div class="container">
  <div class="row">
    <div class="col-8 offset-2 col-md-4 offset-md-2 mt-5">
      <img
        class="img-fluid"
        src="./assets/img/getapollo.io-astronaut.svg"
        alt=""
      />
    </div>
    <div class="col col-md-4 my-md-auto mt-5 text-center text-md-left">
      <h1>{{ 'error-pages.503.title' | translate }}</h1>

      <p>{{ 'error-pages.503.message' | translate }}</p>

      <button
        type="button"
        class="btn btn-outline-primary btn-sm"
        [routerLink]="environment.selfUrl"
      >
        {{ 'error-pages.503.btn' | translate }}
      </button>
    </div>
  </div>
</div>
